// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalSpinner from './internal';
export default function Spinner({ size = 'normal', variant = 'normal', ...props }) {
    const baseComponentProps = useBaseComponent('Spinner', {
        props: { size, variant },
    });
    return React.createElement(InternalSpinner, { size: size, variant: variant, ...props, ...baseComponentProps });
}
applyDisplayName(Spinner, 'Spinner');
//# sourceMappingURL=index.js.map